import { ACTION } from "@common/constants/redux";

export const setNotificationSegmentFilter = (filter) => {
  return (dispatch) => {
    dispatch({
      type: ACTION.SET_NOTIFICATION_SEGMENT_FILTER,
      payload: filter,
    });
  };
};
